import { Loading } from "@/Images"
import { clsx } from "clsx"
import "./style.css"
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  loading: boolean
}
export const ContentLoading = ({ loading, children, className, ...props }: Props) => {
  return (
    <div className={clsx("relative", className)}>
      <div {...props} className="content-loading" data-loading={loading}>
        {loading && (
          <span className="absolute z-[101] animate-spin">
            <Loading />
          </span>
        )}
      </div>
      {children}
    </div>
  )
}
